import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Layout, Select } from "antd";
import { useNavigate } from "react-router";
import { Post } from "../../config/api/post";
import { COACH } from "../../config/constants/api";
import { addUser } from "../../redux/slice/authSlice";
import { SUBJECTS } from "../../config/constants/index";
import swal from "sweetalert";
import { FaArrowLeft } from "react-icons/fa";
import { BsFiles } from "react-icons/bs";
import "../profile/profile.css";
import "./subjects.css";

const navItems = [
  { label: "Profile", path: "/profile" },
  { label: "Education", path: "/education" },
  { label: "Meetings", path: "/meetings" },
  { label: "Subjects", path: "/subjects" },
  { label: "Services", path: "/services" },
  { label: "Hourly Rates", path: "/rates" },
  { label: "Rating & Review", path: "/review" },
  { label: "My Meetings", path: "/my-meetings" },
  { label: "My Assesments", path: "/my-assesments" },
];

const colors = ["#FFEBF6", "#E7FAFF", "#ECE7FF", "#D7FDC3"];

function Subjects() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [mySubjects, setMySubjects] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (user) {
      setMySubjects(user?.subjects || []);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const updateSubjects = () => {
    setLoading(true);

    if (mySubjects.length === 0) {
      swal("Error!", "Atleast one subject is required", "error");
      setLoading(false);
      return;
    }

    Post(COACH.updateProfile, { subjects: mySubjects }, token, null)
      .then((response) => {
        setLoading(false);
        if (response?.data?.status) {
          dispatch(addUser({ user: response.data.data, token: token }));
          swal("Success!", "Subjects Updated Successfully", "success");
          setLoading(false);
          setEditMode(false);
        } else {
          swal("Oops!", response.data.message, "error");
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Layout className="profile-page">
      <section className="profile-hero">
        <div className="profile-wrap profile-hero-inner">
          <button
            type="button"
            className="subjects-back"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <FaArrowLeft />
            Back
          </button>
          <h1 className="fontFamily1 profile-hero-title">Subjects</h1>
          <p className="fontFamily1 profile-hero-sub">
            Choose and manage the subjects you teach on WrightCo Academy.
          </p>
        </div>
      </section>

      <div className="profile-wrap profile-main">
        <div className="profile-layout">
          <aside className="profile-nav">
            <p className="profile-nav-title">Account</p>
            <ul className="profile-nav-list">
              {navItems.map((item) => (
                <li key={item.path}>
                  <button
                    type="button"
                    className={`profile-nav-item${
                      item.path === "/subjects" ? " is-active" : ""
                    }`}
                    onClick={() => navigate(item.path)}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </aside>

          <section className="profile-panel">
            <div className="profile-panel-head">
              <div>
                <h2 className="fontFamily1 profile-panel-title">
                  Your Subjects
                </h2>
                <p className="profile-panel-sub">
                  {editMode
                    ? "Select one or more subjects, then save your changes."
                    : "Subjects currently linked to your trainer profile."}
                </p>
              </div>
            </div>

            {mySubjects.length === 0 ? (
              <div className="subjects-empty">
                <BsFiles aria-hidden />
                <p>No Subjects Found</p>
              </div>
            ) : (
              <div className="subjects-grid">
                {mySubjects.map((item, index) => (
                  <div
                    key={`${item}-${index}`}
                    className="subjects-chip"
                    style={{
                      backgroundColor:
                        colors[Math.floor(index / 4) % colors.length],
                    }}
                  >
                    {String(item).toUpperCase()}
                  </div>
                ))}
              </div>
            )}

            {editMode && (
              <div className="subjects-edit-row">
                <label className="subjects-edit-label" htmlFor="subjects-select">
                  Add Subjects
                </label>
                <Select
                  id="subjects-select"
                  size="large"
                  mode="multiple"
                  maxTagCount="responsive"
                  className="signupSelectBox subjects-select"
                  placeholder="Select Subjects"
                  showSearch
                  value={mySubjects}
                  onChange={(e) => setMySubjects(e)}
                  style={{ minWidth: "100%" }}
                >
                  {SUBJECTS.map((item) => (
                    <option key={item} value={item}>
                      {item[0].toUpperCase() + item.slice(1)}
                    </option>
                  ))}
                </Select>
              </div>
            )}

            <div className="profile-actions">
              {!editMode ? (
                <Button
                  type="primary"
                  className="profile-btn-primary"
                  onClick={() => setEditMode(true)}
                >
                  Edit Subjects
                </Button>
              ) : (
                <>
                  <Button
                    type="primary"
                    className="profile-btn-primary"
                    loading={loading}
                    onClick={() => updateSubjects()}
                  >
                    {loading ? "Loading..." : "Update Subjects"}
                  </Button>
                  <Button
                    className="profile-btn-ghost"
                    ghost
                    size="large"
                    onClick={() => {
                      setMySubjects(user?.subjects || []);
                      setEditMode(false);
                    }}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
}

export default Subjects;
